<template>
  <div class="relative">
    <div class="absolute semibold h6 white center col-12 py1 line-height-2">{{unseenMessages}}</div>
    <svg class="block" width="36" height="34" viewBox="0 0 36 34" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 15.35c0 7.17-7.162 12.986-16 12.986-1.973 0-3.86-.291-5.606-.821L3.2 31.772l3.601-7.15C3.838 22.267 2 18.983 2 15.352 2 8.18 9.162 2.366 18 2.366c8.838 0 16 5.814 16 12.985z" fill="#003665" stroke="#ECECEC" stroke-width="3" fill-rule="evenodd" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
import Util from '@/util';
import { mapGetters } from "vuex";

export default {
  name: 'UnseenMessagesIndicator',
  props: {
    unseenMessages: Number,
  },
};
</script>
